import React from "react";

import { classNames } from "components/utils";
import { CopyCommandButton, StepHeading, TerminalBlock } from "../components";

export const RegisterCommandStep: React.FC<{
  canCopyCommand: boolean;
  commandPlaceholder: string;
  copied: boolean;
  everCopied: boolean;
  hasCompletedStepTwo: boolean;
  onCopy: () => void;
  registerCommand: string;
}> = ({
  canCopyCommand,
  commandPlaceholder,
  copied,
  everCopied,
  hasCompletedStepTwo,
  onCopy,
  registerCommand,
}) => (
  <section
    className={`flex flex-col gap-2 rounded-lg border border-zinc-800 px-4 py-5 ${
      !hasCompletedStepTwo ? "opacity-60" : ""
    }`}
  >
    <StepHeading number={3} isReady={everCopied} highlightWhenReady>
      Run this command on the Linux machine
    </StepHeading>
    <div className="ml-9 min-w-0 overflow-hidden">
      <p className="mb-1 text-sm text-secondary">
        This installs the Brev CLI, then registers the device to the active
        organization.
      </p>
      <p
        className={classNames(
          "mb-2 text-sm",
          hasCompletedStepTwo ? "text-amber-500" : "text-secondary",
        )}
      >
        <span className="font-bold uppercase">Warning:</span>
        <span className="ml-1">
          This command includes your Brev Personal API key. Do not share it.
        </span>
      </p>
      {canCopyCommand ? (
        <TerminalBlock command={registerCommand} />
      ) : (
        <div
          className="w-full truncate rounded-md border border-zinc-800 bg-zinc-900 px-3 py-2.5 font-mono text-sm leading-[1.7] text-zinc-200 opacity-60"
          role="status"
        >
          {commandPlaceholder}
        </div>
      )}
      <CopyCommandButton
        copied={copied}
        disabled={!canCopyCommand}
        onClick={onCopy}
        variant={hasCompletedStepTwo ? "primary" : "secondary"}
      />
    </div>
  </section>
);
